import {
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
} from '@material-ui/core';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import InputIcon from '@material-ui/icons/Input';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { MouseEvent, RefObject } from 'react';
import { useAppHeaderProfileMenuStyles } from './AppHeaderProfileMenu.styles';

type AppHeaderProfileMenuProps = {
  open: boolean;
  anchorRef: RefObject<HTMLButtonElement>;
  handleClose: (event: MouseEvent<EventTarget>) => void;
  goToProfileEdit: () => void;
  logout: () => void;
  switchRole: () => void;
  user: {
    hasMultipleRole?: boolean;
    company_user_role?: { id?: number };
  };
};

const AppHeaderProfileMenu = ({
  open,
  anchorRef,
  handleClose,
  goToProfileEdit,
  logout,
  switchRole,
  user,
}: AppHeaderProfileMenuProps) => {
  const classes = useAppHeaderProfileMenuStyles();

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition={true}
      className={classes.popper}
      placement="bottom-end">
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom-end' ? 'right top' : 'right bottom' }}>
          <Paper className={classes.paper} elevation={0}>
            <ClickAwayListener onClickAway={handleClose}>
              <ul className={classes.list} aria-label="Menu utilisateur">
                <li>
                  <button type="button" className={classes.item} onClick={goToProfileEdit}>
                    <PersonOutlineIcon className={classes.itemIcon} />
                    Mon compte
                  </button>
                </li>

                {user.hasMultipleRole && (
                  <li>
                    <button type="button" className={classes.item} onClick={switchRole}>
                      <AutorenewIcon className={classes.itemIcon} />
                      {user?.company_user_role?.id === 4 ? 'Bénéficiaire' : 'Consultant'}
                    </button>
                  </li>
                )}

                <li>
                  <button
                    type="button"
                    className={classes.item}
                    onClick={logout}
                    data-cy="logout-btn">
                    <InputIcon className={classes.itemIcon} />
                    Déconnexion
                  </button>
                </li>
              </ul>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default AppHeaderProfileMenu;
